<a class="card-movie" (click)="goMovie($event, movie.id)" href={{movieLink}} [class.useHover]="useHover">
    <div class="principal">

        <!-- Cocarda Free-->
        <div class="tarjeta__cocarda" *ngIf="isFree">
            <div class="tarjeta__cocarda-line">
                GRATIS
            </div>
        </div>
        <!-- Cocarda Estreno-->
        <div class="tarjeta__cocarda" *ngIf="esEstreno">
            <div class="tarjeta__cocarda-line line-estreno">
                ESTRENO
            </div>
        </div>
        <!-- Cocarda Sala-->
        <div class="tarjeta__cocarda" *ngIf="esCinema">
            <div class="tarjeta__cocarda-line line-salas">
                EN SALAS
            </div>
        </div>

        <!-- <div class="fade-corner h-100 w-100"></div> -->
        <img class="imagen" src="{{fotoPrincipal | ThumbnailImage}}" alt="">

        <div class="fondo"></div>

        <div class="informacion">
            <div class="titulo">{{ movie.title }}</div>
            <div class="reparto">{{ nombreCompletoDirector }}</div>
        </div>
    </div>


    <div class="hover">
        <div class="seccion">
            <span class="titulo">{{ movie.title }}</span>
            <span class="anio">{{ movie.releaseYear }}</span>
            <span class="duracion">{{ movie.length }} min</span>

            <div class="sinopsis">
                <p [innerHTML]="movie.synopsis"></p>
            </div>
        </div>
    </div>
</a>